import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  Heading,
  Stack,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api_url } from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";

const UpdateCandidate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    enrollmentNo: "",
    category: "",
    aboutus: "",
  });

  const [files, setFiles] = useState({
    photo: null,
    barIdPhoto: null,
    coverLaterpdf: null,
  });

  // 🔹 Fetch candidate details
  const fetchCandidate = async () => {
    try {
      const data = await axios.get(
        `${api_url}/api/v1/election/candidate/${id}`
      );
      setFormData(data.data);
    } catch (error) {
      toast({
        title: "Failed to load candidate",
        status: "error",
      });
    }
  };

  // 🔹 Fetch categories
  const fetchCategories = async () => {
    const data = await axios.get(
      `${api_url}/api/v1/superAdmin/get_all_election_category`
    );
    setCategories(data.data);
  };

  useEffect(() => {
    fetchCandidate();
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  // 🔹 Submit update
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key]) data.append(key, formData[key]);
      });

      Object.keys(files).forEach((key) => {
        if (files[key]) data.append(key, files[key]);
      });

      await axios.put(
        `${api_url}/api/v1/election/candidate/update/${id}`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast({
        title: "Candidate updated successfully",
        status: "success",
      });

      navigate("/admin/candidates");
    } catch (error) {
      toast({
        title: error.response?.data?.message || "Update failed",
        status: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />

      <Box ml={{ base: 0, md: "250px" }} mt="70px" p={5} bg="gray.50">
        <Heading mb={6} size="lg">
          Update Candidate
        </Heading>

        <form onSubmit={handleSubmit}>
          <Stack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Name</FormLabel>
              <Input
                name="name"
                value={formData?.name}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input
                name="email"
                value={formData?.email}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Mobile</FormLabel>
              <Input
                name="mobile"
                value={formData?.mobile}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Enrollment No</FormLabel>
              <Input
                name="enrollmentNo"
                value={formData?.enrollmentNo}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Category</FormLabel>
              <Select
                name="category"
                value={formData?.category}
                onChange={handleChange}
              >
                <option value="">Select category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>About</FormLabel>
              <Textarea
                name="aboutus"
                value={formData?.aboutus}
                onChange={handleChange}
              />
            </FormControl>

            {/* Files (optional) */}
            <FormControl>
              <FormLabel>Photo</FormLabel>
              <Input type="file" name="photo" onChange={handleFileChange} />
            </FormControl>

            <FormControl>
              <FormLabel>Bar ID Photo</FormLabel>
              <Input
                type="file"
                name="barIdPhoto"
                onChange={handleFileChange}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Cover Letter PDF</FormLabel>
              <Input
                type="file"
                name="coverLaterpdf"
                onChange={handleFileChange}
              />
            </FormControl>

            <Button colorScheme="blue" type="submit" isLoading={loading}>
              Update Candidate
            </Button>
          </Stack>
        </form>
      </Box>
    </>
  );
};

export default UpdateCandidate;
